import { render, staticRenderFns } from "./TrackingMadrillas.vue?vue&type=template&id=fff48510"
import script from "./TrackingMadrillas.vue?vue&type=script&lang=js"
export * from "./TrackingMadrillas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports